export default (theme) => ({
  overflowEllipsis: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "180px",
    padding: 0,
    margin: 0,
    marginRight: 20,
  },
});